import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const changeStatusSound = createAction(Constants.CHANGE_STATUS_SOUND, params => params);
export const success = createAction(Constants.SOUND_CONSTANT.SUCCESS);
export const error = createAction(Constants.SOUND_CONSTANT.ERROR, payload => payload);
export const warning = createAction(Constants.SOUND_CONSTANT.WARNING, params => params);
export const normal = createAction(Constants.SOUND_CONSTANT.NORMAL, params => params);
